import { track } from '../activity/activity-client';
import { onSystemEvent } from './system-events';

/**
 * Conecta eventos técnicos del sitio al Tracker de actividad (`track_event`,
 * visible en `/admin/activity`) — no a `system_errors`: son cosas que pasan
 * seguido y no ameritan que alguien del equipo lo revise como si el sistema
 * estuviera roto (por ejemplo, la conexión del chat cortándose un instante
 * durante el long-poll). Igual quedan registradas para poder ver cuánto
 * pasa, sin ser ruido en el panel de errores.
 *
 * Se llama una sola vez, al arrancar la aplicación (`main.tsx`). Si mañana
 * un evento deja de interesar, se borra su línea acá — el sitio que lo
 * dispara (`emitSystemEvent`) no se toca.
 */
export function registerSystemEventTrackers(): void {
  onSystemEvent('chat-poll-degraded', (detail) => track('chat_poll_degraded', detail));
}
